import {
  AnimatedLineSeries,
  Axis,
  XYChart,
  darkTheme,
  lightTheme,
} from '@visx/xychart';

import { useColorScheme } from '@/hooks/useColorScheme';
import { PromptOptimizationResult } from '@/types/schema';

export const MetricsOverTimeChart = ({
  results,
}: {
  results: PromptOptimizationResult[];
}) => {
  const { isDarkMode } = useColorScheme();

  // If no results, show empty chart with just axes
  const emptyData = results.length === 0 ? [{ x: 0, y: 0 }] : results;

  return (
    <XYChart
      height={300}
      xScale={{ type: 'band' }}
      yScale={{ type: 'linear' }}
      margin={{ top: 30, right: 10, bottom: 40, left: 60 }}
      theme={isDarkMode ? darkTheme : lightTheme}
    >
      <Axis
        orientation="left"
        numTicks={5}
        label="score"
        tickLabelProps={{
          dx: -10,
        }}
      />
      <Axis orientation="bottom" label="epochs" labelOffset={10} />
      <AnimatedLineSeries
        dataKey="x"
        data={emptyData}
        xAccessor={(d) => d.x}
        yAccessor={(d) => d.y}
      />
    </XYChart>
  );
};
